import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector } from "react-redux";
import { useEffect,useState } from 'react';
import dayjs from 'dayjs';
import { Box, Grid, Typography } from '@mui/material';
import '../../../../cssfiles/homepage.css'

const SingleValueWidget = ({ props,sensorNumber }) => {
  const [value, setValue] = useState(0)
    const [time, setTime] = useState("01-01-1970 00:00:00")
    const livedata = useSelector((state) => state.mainpagedata.livedata);

  useEffect(() => {
    console.log("in bb-",sensorNumber,livedata?.length,)
      if (livedata?.length && props.widgetprop.widgetlist[sensorNumber-1]?.props?.extended?.tagprops?.[0]?.tagid) {
          for(let i=0; i<livedata.length; i++) {
              const tagId = props.widgetprop.widgetlist[sensorNumber-1]?.props?.extended?.tagprops?.[0]?.tagid;
              console.log("livedata in bb-t",tagId)
              if(parseInt(tagId) === parseInt(livedata[i].TagId)) {
                  setValue(livedata[i].value.toFixed(2))
                  const date = new Date(livedata[i].timestamp * 1000)
                  const month = date.getMonth()+1;
                  const timestamp = (date.getDate() > 9 ? date.getDate() : "0"+date.getDate()) + "-" + 
                                 (month > 9 ? month : "0"+ month) + "-" + 
                                 date.getFullYear() + " " + 
                                 (date.getHours() > 9 ? date.getHours() : "0"+date.getHours()) + ":" + 
                                 (date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes()) + ":" + 
                                 (date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds())
                  setTime(timestamp)
              }
          }
      }
  }, [livedata, props.widgetprop]);

    return (
        <Box
            sx={{
                width: "80%",
                height: "150px",
                backgroundColor: "var(--SecondaryBackground)",
                border: "none",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "16px",
                margin: "8px",
            }}
        >
            <Typography
                sx={{
                    fontFamily: "Roboto",
                    fontSize: "24px",
                    fontWeight: 400,
                    color: "var(--PrimaryText)",
                    textAlign: "center",
                }}
            >
                {value}
            </Typography>
            <Typography
                sx={{
                    fontFamily: "Roboto",
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "var(--PrimaryText)",
                    mt: 1,
                }}
            >
                {`Temperature Sensor ${sensorNumber} (°C)`}
            </Typography>
            <Typography
                sx={{
                    fontFamily: "Roboto",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "var(--SecondaryText)",
                }}
            >
                {time}
            </Typography>
        </Box>
    );
};

export default function Valuedatacard(props){
    const theme = useSelector((state) => state.themedata.theme)
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
    
    
    const [optionsmin, setOptionsMin] = useState(0);
    const [optionsmax, setOptionsMax] = useState(0);
    const [optionstimemin, setOptionsTimeMin] = useState(0);
    const [optionstimemax, setOptionsTimeMax] = useState(0);
    const [widgetnamedisplay, setWidgetName] = useState(0);
    const [image, setImage] = useState("");
    const [height, setHeight] = useState("98%");
    const [width, setWidth] = useState("100%");
    
    useEffect(() => {
        if (props.widgetprop?.props?.extended?.Logo) {
            const logoProps = props.widgetprop.props.extended.Logo;
            setImage(logoProps.base64);
            setHeight(logoProps.height);
            setWidth(logoProps.width);
        }
    }, [props.widgetprop]);
    
    useEffect(() => {
        const tagProperties = props.widgetprop?.props?.extended?.tagprops || [];
        const widgetname = props.widgetprop?.widgetname;
        
        tagProperties.forEach(chartType => {
            if (chartType && tagcollectionvalue && tagcollectionvalue.hasOwnProperty(chartType.tagname)) {
                const nestedvalue = tagcollectionvalue[chartType.tagname]
                let min = 10000000000;
                let max = 0.0;
                let mintime = 0.0;
                let maxtime = 0.0;
                const options = { timeZone: "Asia/Kolkata" };
                
                for(let i=0; i<nestedvalue.length; i++){
                    if(Number(nestedvalue[i].y) > max){
                        max = Number(nestedvalue[i].y);
                        const currentmaxformatteddate = new Date(nestedvalue[i].x);
                        const maxformatteddate = currentmaxformatteddate.toLocaleDateString('en-us', { 
                            ...options, 
                            day: "numeric", 
                            month: "short", 
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            second: "numeric" 
                        });
                        maxtime = maxformatteddate;
                    }else if(Number(nestedvalue[i].y) < min){
                        min = Number(nestedvalue[i].y);
                        const currentminformatteddate = new Date(nestedvalue[i].x);
                        const minformatteddate = currentminformatteddate.toLocaleDateString('en-us', { 
                            ...options, 
                            day: "numeric", 
                            month: "short", 
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            second: "numeric" 
                        });
                        mintime = minformatteddate;
                    }
                }
                setOptionsMin(min);
                setOptionsMax(max);
                setOptionsTimeMin(mintime);
                setOptionsTimeMax(maxtime);
            }
        });
    }, [props.widgetprop, tagcollectionvalue]);

    
    const sensorData = Array.from({ length: 12 }, (_, index) => ({
        sensorNumber: index + 1
    }));

    return (
        <Grid container spacing={2} sx={{ height: "100%", boxSizing: "border-box" }}>
            {/* Left side - Technical Diagram */}
            <Grid item xs={4} sx={{ height: "100%", boxSizing: "border-box" }}>
                <Box
                    sx={{
                        height: "100%",
                        backgroundColor: "var(--SecondaryBackground)",
                        border: "none",
                        padding: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        boxSizing: "border-box",
                    }}
                >
                    <img
                        src={image}
                        alt="Technical Diagram"
                        style={{
                            height: height,
                            width: width,
                            objectFit: "contain",
                        }}
                    />
                </Box>
            </Grid>

            {/* Right side - Temperature Sensors */}
            <Grid item xs={8} sx={{ height: "100%", boxSizing: "border-box" }}>
                <Box
                    sx={{
                        height: "100%",
                        backgroundColor: "var(--PrimaryBackground)",
                        border: "none",
                        padding: "12px",
                        overflowY: "auto",
                    }}
                >
                    <Grid
                        container
                        sx={{
                          height :"100%",
                            margin: "-8px",
                            width: "calc(100% + 16px)",
                        }}
                    >
                        {sensorData.map((data, index) => (
                            <Grid item xs={3} key={index}>
                                <SingleValueWidget
                                    props={props}
                                    // value={value}
                                    // time={time}
                                    sensorNumber={data.sensorNumber}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    );
}